"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEmployeesByIds = exports.GetEmployeeById = exports.Employee = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const user_model_1 = require("./user.model");
class Employee extends user_model_1.User {
    constructor() {
        super(...arguments);
        this.expensesSoFar = 0;
        this.getInitials = () => `${this.firstName.charAt(0).toUpperCase()}${this.lastName.charAt(0).toUpperCase()} `;
        this.getFullName = () => {
            if (!this.firstName && !this.lastName) {
                return "";
            }
            return `${this.firstName} ${this.lastName}`;
        };
        this.isInAbsenceOfLeave = () => { var _a, _b; return (this.absence ? (0, moment_timezone_1.default)().isBetween((_a = this.absence) === null || _a === void 0 ? void 0 : _a.startDate, (_b = this.absence) === null || _b === void 0 ? void 0 : _b.endDate, "day", "[]") : false); };
        this.inAbsenceOfLeaveFor = () => { var _a; return (this.isInAbsenceOfLeave() ? (0, moment_timezone_1.default)((_a = this.absence) === null || _a === void 0 ? void 0 : _a.endDate).diff((0, moment_timezone_1.default)().startOf("day"), "days") + 1 : 0); };
        this.setActiveCompanyProfile = (companyId) => (this.activeCompanyProfile = this.getUserCompanyProfile(companyId) || {});
    }
}
exports.Employee = Employee;
const GetEmployeeById = (employees, id) => employees.find((employee) => employee.id === id);
exports.GetEmployeeById = GetEmployeeById;
const GetEmployeesByIds = (employees, ids) => {
    if (!ids) {
        return [];
    }
    return employees.filter((employee) => ids.includes(employee.id));
};
exports.GetEmployeesByIds = GetEmployeesByIds;
